import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuiaCompleto from "../pages/artigo/guia-completo-hoobuy-spreadsheet/page";
import GuiaDeCompras from "../pages/artigo/guia-de-compras-hoobuy/page";
import HoobuySeguro from "../pages/artigo/hoobuy-e-seguro/page";
import ComoComprarPortugal from "../pages/artigo/como-comprar-hoobuy-portugal/page";
import HoobuyVsPandabuy from "../pages/artigo/hoobuy-vs-pandabuy/page";
import MelhoresTenis from "../pages/artigo/melhores-tenis-hoobuy-2026/page";
import PlanilhaAtualizada from "../pages/artigo/planilha-hoobuy-atualizada-2026/page";
import LinksVerificados from "../pages/artigo/hoobuy-links-verificados/page";
import MelhorAgente from "../pages/artigo/melhor-agente-hoobuy-2026/page";
import HoobuyYupoo from "../pages/artigo/hoobuy-yupoo-guia/page";
import GuiaTamanhos from "../pages/artigo/guia-tamanhos-hoobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/guia-completo-hoobuy-spreadsheet",
    element: <GuiaCompleto />,
  },
  {
    path: "/artigo/guia-de-compras-hoobuy",
    element: <GuiaDeCompras />,
  },
  {
    path: "/artigo/hoobuy-e-seguro",
    element: <HoobuySeguro />,
  },
  {
    path: "/artigo/como-comprar-hoobuy-portugal",
    element: <ComoComprarPortugal />,
  },
  {
    path: "/artigo/hoobuy-vs-pandabuy",
    element: <HoobuyVsPandabuy />,
  },
  {
    path: "/artigo/melhores-tenis-hoobuy-2026",
    element: <MelhoresTenis />,
  },
  {
    path: "/artigo/planilha-hoobuy-atualizada-2026",
    element: <PlanilhaAtualizada />,
  },
  {
    path: "/artigo/hoobuy-links-verificados",
    element: <LinksVerificados />,
  },
  {
    path: "/artigo/melhor-agente-hoobuy-2026",
    element: <MelhorAgente />,
  },
  {
    path: "/artigo/hoobuy-yupoo-guia",
    element: <HoobuyYupoo />,
  },
  {
    path: "/artigo/guia-tamanhos-hoobuy",
    element: <GuiaTamanhos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;